// extracted by mini-css-extract-plugin
export default {"position_kyc":"Kyc_position_kyc__Mp2L1","center_popup":"Kyc_center_popup__8ZYLH"};